import { Component } from '@angular/core';

import { NgClass } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { FieldBaseComponent } from '@shared/components/forms/components/field-base';

@Component({
  selector: 'lib-form-alert',
  templateUrl: 'form-alert.component.html',
  imports: [FormsModule, ReactiveFormsModule, NgClass],
})
export class FormAlertComponent extends FieldBaseComponent {
  public getSeverityClass() {
    switch (this.config?.severity) {
      case 'danger':
        return 'alert alert-danger';
      case 'info':
      default:
        return 'alert alert-info';
    }
  }
}
